<template>
  <div>
    <div id="ng-messagecenter-thread">
      <div
        class="messagecenter-thread"
        v-if="threadID > 0">
        <div class="messagecenter-thread-messages">
          <ul>
            <li
              v-for="item in threadMessages"
              :key="item.order"
              :class="{
                household: item.linktype === 'household',
                last: item.last
              }">
              <div class="name">
                <p>{{ item.name }}</p>
              </div>
              <div class="date">
                <p>{{ item.dateortime }}</p>
              </div>
              <div
                class="text"
                :class="{ household: item.linktype === 'household' }">
                <p>{{ item.text }}</p>
                <div
                  v-for="(attachedFile, index) in splitJoin(
                    item.fileattachment
                  )"
                  :key="index">
                  <a v-if="attachedFile && attachedFile != ''"
                    class="no-overlay"
                    :download="attachedFile"
                    :href="
                      'messagecenter.html?action=ViewFile&BlobFileName=' +
                      '%5cMessage Center%5c' +
                      item.iddetail +
                      '%5c' +
                      attachedFile +
                      '&_csrf_token=' +
                      csrfToken
                    "
                    >{{ attachedFile }} (Download)</a
                  >
                  <br />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="messagecenter-thread-empty"
        v-if="threadID <= 0">
        <p class="title">No message selected.</p>
        <p class="text">
          Select a new message from the message center inbox to activate the
          message pane.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ThreadMessagesComponent',
  props: {
    messageThreadIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      threadID: this.messageThreadIndex,
      threadMessages: [],
      timerMessages: '',
      csrfToken: App.settings.CSRFToken
    }
  },
  created() {
    this.fetchThreadMessages()
    this.timerMessages = setInterval(this.fetchThreadMessages, 60000)
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(function () {
        let container = document.querySelector(
          '#ng-messagecenter-thread .messagecenter-thread-messages ul li.last'
        )
        container.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }, 1000)
    })
  },
  methods: {
    splitJoin(theText) {
      return theText.split(',')
    },
    fetchThreadMessages() {
      if (this.threadID === 0) {
        return
      }

      axios.get('api/messagecenter/messages/' + this.threadID).then((data) => {
        this.threadMessages = Array.isArray(data.data.threadMessages)
          ? data.data.threadMessages
          : []

        if (data.data.numberOfMessages != undefined) {
          $('#menu_messagecenter .menuitem__text').html(
            data.data.numberOfMessages
          )
        }
      })
    }
  },

  beforeUnmount() {
    clearInterval(this.timerMessages)
  }
}
</script>

<style lang="less">
@import '../assets/css/abstract/variables.less';
@import '../assets/css/abstract/mixins.less';

#ng-messagecenter-thread {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  float: left;

  .messagecenter-thread-messages {
    width: 100%;
    overflow-y: auto;
    border-bottom: solid 1px rgba(192, 192, 192, 0.5);
    float: left;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      position: relative;
      z-index: 1;
      display: block;
      overflow: auto;
      height: 500px;

      overflow: hidden;
      overflow-y: scroll;

      li {
        list-style: none;
        padding: 0;
        margin: 16px;
        width: 70%;
        float: left;

        .name {
          font-size: @font-size-12px;
          color: #6e6868;
          height: 20px;
          float: left;

          p {
            font-weight: 400;
            padding: 0;
          }
        }

        .date {
          font-size: @font-size-12px;
          color: #6e6868;
          height: 20px;
          float: right;

          p {
            font-weight: 400;
            padding: 0;
            text-align: right;
          }
        }

        .text {
          font-size: @font-size-14px;
          width: 100%;
          float: left;
          border-radius: 8px;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%);
          border: solid 1px rgba(192, 192, 192, 0.5);
          background-color: #fff; //@color-off-white
          padding: 10px;

          p {
            font-weight: 400;
            padding: 0;
          }
        }

        .household {
          color: #fff;
          background-color: @primary-color;

          a {
            .default-focus-indicator(-9px, #FFF);
            color: #fff;
            padding: 10px;
          }
        }
      }

      li.household {
        float: right;
      }
    }
  }

  .messagecenter-thread-empty {
    height: 638px;
    margin: 80px;

    .title {
      color: @primary-color;
      font-size: @font-size-16px;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }

    .text {
      font-size: @font-size-14px;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
